import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor  {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(`token`)) return next.handle(request); // checks the login path
    
    let clonedRequest = null;
    let headers = request.headers.set(`Authorization`, `Bearer ${this.storageService.GetToken()}`);
    
    clonedRequest = request.clone({headers});

    return next.handle(clonedRequest);
  }
}
